import script from "./THChartCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./THChartCard.vue?vue&type=script&setup=true&lang=ts"

import "./THChartCard.vue?vue&type=style&index=0&id=7c8bee27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8bee27"]])

export default __exports__